import { Command } from 'ckeditor5'

export class PasteCommand extends Command {
  async execute() {
    const editor = this.editor

    try {
      if (navigator.clipboard && navigator.clipboard.read) {
        const clipboardItems = await navigator.clipboard.read()

        for (const clipboardItem of clipboardItems) {
          // Try to get HTML content first
          if (clipboardItem.types.includes('text/html')) {
            const htmlBlob = await clipboardItem.getType('text/html')
            const htmlText = await htmlBlob.text()

            if (htmlText) {
              // Convert HTML to view using data processor
              const viewFragment = editor.data.processor.toView(htmlText)

              // Convert view to model
              const modelFragment = editor.data.toModel(viewFragment)

              editor.model.insertContent(modelFragment)
              return
            }
          }

          // Fallback to plain text
          if (clipboardItem.types.includes('text/plain')) {
            const textBlob = await clipboardItem.getType('text/plain')
            const plainText = await textBlob.text()

            if (plainText) {
              // Convert plain text to view
              const viewFragment = editor.data.processor.toView(plainText)

              // Convert view to model
              const modelFragment = editor.data.toModel(viewFragment)

              editor.model.insertContent(modelFragment)
              return
            }
          }
        }
      } else {
        console.warn('Clipboard API not available')
      }
    } catch (error) {
      console.warn('Clipboard API not available')
    }
  }

  refresh() {
    this.isEnabled = true
  }
}
